export const filterString = (filter) => filter ? `?${Object.keys(filter).map( f => `${f}=${filter[f]}`).join("&")}` : "";